import { successToast, toast } from "hooks/use-toast";

export const notifySaved = (description: string) => successToast({ description });

export const notifyFailed = (title: string, error: unknown) =>
  toast({
    variant: "destructive",
    title,
    description: error instanceof Error ? error.message : undefined,
  });
